import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import  { MdCheckbox, MdSnackbar, MdCard, MdButton, MdField, MdProgress } from 'vue-material/dist/components'

//import "vue-material/dist/vue-material.css"

Vue.use(MdSnackbar)
Vue.use(MdCard)
Vue.use(MdButton)
Vue.use(MdField)
Vue.use(MdProgress)
Vue.use(MdCheckbox)

//import './assets/snackbar.css'

new Vue({
  render: h => h(App),
}).$mount('#app')
